import { Box, Grid } from "@mui/material";
import { teal } from "@mui/material/colors";
import { bouncy } from "ldrs";

bouncy.register();

export default function LoadingComponent(props: { message: string }) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box m={8} justifyContent={"center"} textAlign="center">
          <l-bouncy size="108" speed="1.4" color={teal[400]}></l-bouncy>
          <div>
            <h3>{props.message}</h3>
          </div>
        </Box>
      </Grid>
    </Grid>
  );
}
